import React from 'react'

import ColumnLink from './ColumnLink'
import Text from '../Text'
import "./column_links.css"

const ColumnLinks = ((props)=>(
	<div className="column_links">
		<h3>{props.title}</h3>
		<Text text={props.text} />
		<div className="container__column_links">
		{ 
			props && props.columnLinks ? props.columnLinks.map((link)=>(
				<ColumnLink {...link} key={link.id} />
			)): ''
		}
		</div>
	</div>
))

export default ColumnLinks


// WEBPACK FOOTER //
// ./src/Components/ColumnLinks/index.js